import pkg from '../../package.json' with { type: 'json' }
import { startFromScript } from './start'
import type { Stub } from './start'

const script = document.currentScript
const page = window as unknown as { loomduct?: Stub }

if (!(script instanceof HTMLScriptElement)) {
  console.warn('[loomduct] no script tag')
} else if (!page.loomduct?.[Symbol.for('loomduct.instance')]) {
  page.loomduct = startFromScript(
    script,
    page.loomduct,
    pkg.version,
  ) as unknown as Stub
}
